// @ts-nocheck

export const defaultPageSize = 20;
